// Use .js: CRA treats .cjs as a static asset rather than executable code.
// Barcode editing uses registered selling units, not an invented stock unit.
const key = value => String(value || '').trim().toLowerCase();
function salesUnits(product) {
  return (product?.units || []).filter(unit => typeof unit.name === 'string' && unit.name.trim());
}
function selectBarcodeUnit(product, kind = 'sales', name, code = '') {
  if (kind === 'new_unit') return {kind, name: '', barcode: '', pieces: ''};
  const receiving = kind === 'receiving';
  const units = receiving ? (product.receiving_packages || []) : salesUnits(product);
  const unit = name !== undefined ? units.find(u => u.name === name)
    : units.find(u => code && key(u.barcode) === key(code)) || units[0];
  const base = !receiving && unit && key(unit.name) === key(product.base_unit) && Number(unit.pieces) === 1;
  return {
    kind: receiving ? 'receiving' : base ? 'base' : 'unit',
    name: unit?.name || '',
    barcode: unit?.barcode || (base ? product.barcode : '') || '',
    pieces: unit ? String(unit.pieces) : '',
  };
}
function validSalesSelection(product, draft) {
  if (draft.kind === 'receiving' || draft.kind === 'new_unit') return true;
  const unit = salesUnits(product).find(u => u.name === draft.name);
  return !!unit && selectBarcodeUnit(product, 'sales', unit.name).kind === draft.kind;
}
function needsUnitPrice(product, name) {
  if (!(product?.pda_unit_names || []).some(n => key(n) === key(name))) return false;
  return ![...(product.units || []), ...(product.price_tiers || [])].some(u =>
    key(u.name) === key(name) && Number(u.price) > 0 && Number(u.min_qty || 1) <= 1);
}
module.exports = { salesUnits, selectBarcodeUnit, validSalesSelection, needsUnitPrice };
